import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { LANDING } from "@/constants/testIds";
import { fadeUp, revealProps, stagger } from "@/lib/motion";

const FAQS = [
  {
    q: "Сколько длится сказка?",
    a: "Пять–семь минут чтения или озвучки: как раз, чтобы уложить.",
  },
  {
    q: "Можно ли переделать, если не понравилось?",
    a: "Да, в чате можно попросить другой сюжет или поправить детали — доплачивать не нужно.",
  },
  {
    q: "Это безопасно для ребёнка?",
    a: "Да, сказка развлекательная и поддерживающая, без пугающих сюжетов.",
  },
  {
    q: "Можно ли сказку про конкретную ситуацию?",
    a: "Да: садик, страх темноты, дружба, смелость, новый братик. Расскажите ситуацию своими словами — сказка мягко её проговорит.",
  },
  {
    q: "Что даёт подписка на канал?",
    a: "Каждый вечер бесплатная сказка с озвучкой, иногда с видео. Раз в неделю подписчикам начисляется дополнительная бесплатная сказка на сайте.",
  },
];

const FAQ = () => {
  return (
    <section id="faq" className="bg-night-900 py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <motion.div {...revealProps} variants={stagger(0.08)} className="mb-10 text-center">
          <motion.p variants={fadeUp} className="mb-3 text-[11px] uppercase tracking-[0.22em] text-amber">
            FAQ
          </motion.p>
          <motion.h2 variants={fadeUp} className="font-serif text-3xl text-cream sm:text-4xl lg:text-5xl">
            Вопросы и ответы
          </motion.h2>
        </motion.div>

        <motion.div {...revealProps} variants={fadeUp}>
          <Accordion
            type="single"
            collapsible
            data-testid={LANDING.faqAccordion}
            className="overflow-hidden rounded-3xl border border-line bg-white/[0.04] px-5 backdrop-blur-xl sm:px-7"
          >
            {FAQS.map((item, i) => (
              <AccordionItem
                key={item.q}
                value={`item-${i}`}
                data-testid={`${LANDING.faqItemPrefix}${i + 1}`}
                className="border-line last:border-b-0"
              >
                <AccordionTrigger className="text-left font-serif text-lg text-cream hover:text-amber-soft hover:no-underline sm:text-xl">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="leading-relaxed text-muted-foreground">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
